import { render, staticRenderFns } from "./OutwardsTreatyPremium.vue?vue&type=template&id=a24f1534&"
import script from "./OutwardsTreatyPremium.vue?vue&type=script&lang=js&"
export * from "./OutwardsTreatyPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports